import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ChartDataSets } from 'chart.js';
import { numberToString } from 'igniteui-angular-core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Label, SingleDataSet } from 'ng2-charts';
import { ToastrManager } from 'ng6-toastr-notifications';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { _ENDPOINT } from '../../endpoints/endpoint';
import { NetworkService } from '../../services/network.service';
import { ReportingService } from '../../services/reporting.service';
import { Utility } from '../../utility/utility';
import { environment } from '../../../environments/environment';
import { mapCountryDropdownItem, mapCountryDropdownItems } from '../../utility/country.util';

@Component({
  selector: 'app-reporting-view',
  templateUrl: './reporting-view.component.html',
  styleUrls: ['./reporting-view.component.css']
})
export class ReportingViewComponent implements OnInit, OnDestroy {

  dropdownListBO: any[];
  selectedItemsBO: any[] = [];
  dropdownListOrderCluster: any[];
  selectedItemsOrderCluster: any[] = [];
  dropdownListCustomer: any[];
  selectedItemsCustomer: any[] = [];
  dropdownListCountry: any[];
  selectedItemsCountry: any[] = [];
  dropdownListMonth: any[];
  selectedItemsMonth: any[] = [];
  dropdownListYear: any[];
  selectedItemsYear: any[] = [];
  dropdownListOrderType: any[];
  selectedItemsOrderType: any[] = [];
  selectedItemsIdGlobal: any[] = [];
  dropdownSettings: IDropdownSettings = {};
  destroy$ = new Subject<boolean>();
  responseTendineInventory: any = {};
  customerOfCountry: Map<string, string[]>;
  orderTypeOfOrderCLuster: Map<string, string[]>;
  idLeadGlobalOfCustomerName: Map<string, string[]>;
  listOrder: any[] = [];

  listOrderSelected: any[] = [];

  reportResponse: any;

  pieChartLabels: Label[] = [];
  pieChartData: SingleDataSet = [];


  orders: any[] = [];
  listAverage: any[] = [];
  chart_Data: ChartDataSets[] = [];
  chart_DataCompleted: ChartDataSets[] = [];
  chart_Labels: Label[];

  dropdownListOrderStatus: any[];
  selectedItemsOrderStatus: any[] = [];
  dropdownListLead: any[];
  selectedItemsLead: any[] = [];

  labelSlaKpi: Label[];
  singleDataSetSlaKpi: SingleDataSet = [];

  colors: string[] = [
    '#00D2AE', '#F8AFA6', '#FDB750', '#D4F1F4', '#D3F4FB', '#DFF1FF', '#C2FCF4', '#F2F1F0', '#F9F871',
    '#F9F1F0', '#FEFAE5', '#FCFAF0', '#322D2F', '#05445E', '#2F5233', '#53565A', '#116530', '#4A5977', '#870DD9', '#636059', '#2C65BA',
    '#0064D2', '#75668F', '#8461BA', '#C85250', '#A664B5', '#E43D40', '#A7729A', '#82858E', '#F2059F',
    '#0785F2', '#F24150', '#FC2E20', '#4889DE', '#008FD7', '#189AB4', '#E7625F', '#05A63A', '#18A558',
    '#F85C70', '#A483E3', '#8D9797', '#00A79B', '#F26E22', '#D57F96', '#00AD7D', '#F37970', '#00AAEA',
    '#FD7F20', '#21B6A8', '#00B3D0', '#76B947', '#F79489', '#B5B2B0', '#00C7E2', '#AEB8C4', '#94C973',
    '#59D7EE', '#C0C9CC', '#C0C9D0', '#C1C8D9', '#7DD4F7', '#53DFD1',
    '#C4CEC5', '#F7BEC0', '#CBCDCB', '#FABEC0', '#B1D8B7', '#FFBDEE', '#66E8C1', '#75E6DA', '#88EA85',
    '#9DE3F6', '#CCDCDB', '#A6E8BB', '#84F0AD', '#A3EBB1', '#E3D9E0', '#A8F597', '#FADCD9', '#A1F7A1',
    '#E5E8E8', '#E9EAE0', '#CFF882',
  ];

  constructor(private networkService: NetworkService, private toastr: ToastrManager,
    private spinner: NgxSpinnerService, private reportingService: ReportingService) {

  }

  ngOnInit() {
    this.reportingService.initReportingService();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 4,
      allowSearchFilter: true
    };
    this.initializeTendine();
  }

  initializeTendine() {

    this.spinner.show("sp1");
    let urlTendineReporting: string = environment.basePath + _ENDPOINT.getTendineReporting;
    let data = {
      body: ''
    }
    this.networkService.post(urlTendineReporting, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {
        if (this.networkService.checkEnvironmentIsDev()) {
          if (response && response.statusCode == '200' && response.body && response.body.length > 0) {
            this.responseTendineInventory = JSON.parse(response.body);
            this.initTendineCountryAndCustomer(this.responseTendineInventory);
            this.initTendine(this.responseTendineInventory);
            this.spinner.hide("sp1");

          } else if (response && response.statusCode == '500' && response.body && response.body.length > 0) {
            this.spinner.hide('sp1');
            this.toastr.errorToastr(response.body, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        } else {
          if (response && response.customerOfCountry) {
            this.responseTendineInventory = response;
            this.initTendineCountryAndCustomer(this.responseTendineInventory);
            this.initTendine(this.responseTendineInventory);
            this.spinner.hide("sp1");
          } else if (response && response.length && response.length > 0) {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr(response.toString(), 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          } else {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr('Error during selectItem reporting Retrieve', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        }
      },
        err => {
          this.spinner.hide("sp1");
          this.toastr.errorToastr('Error during selectItem reporting Retrieve', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          console.error(err);
        });
  }

  initTendineCountryAndCustomer(responseTendineInventory: any) {
    if (responseTendineInventory && responseTendineInventory.customerOfCountry
      && responseTendineInventory.orderTypeOfOrderCLuster) {
      this.customerOfCountry = new Map(Object.entries(responseTendineInventory.customerOfCountry));
      this.orderTypeOfOrderCLuster = new Map(Object.entries(responseTendineInventory.orderTypeOfOrderCLuster));
      this.idLeadGlobalOfCustomerName = new Map(Object.entries(responseTendineInventory.idLeadGlobalOfCustomerName));
      this.initDropdownCountryCustomer();
    }
  }

  initDropdownCountryCustomer() {
    let country: any[] = [];
    let customer: any[] = [];
    for (let [key, value] of this.customerOfCountry) {
      let data = mapCountryDropdownItem({ item_id: key, item_text: key });
      if (country.indexOf(data) == -1) {
        country.push(data);
      }
      for (let elem of value) {
        let dataCustomer = { item_id: elem, item_text: elem };
        let cust = customer.find(x => x.item_id == dataCustomer.item_id);
        if (!cust) {
          customer.push(dataCustomer);
        }

      }
    }
    this.dropdownListCountry = mapCountryDropdownItems(country);
    this.dropdownListCustomer = customer;
  }

  initTendine(responseTendineInventory: any) {
    this.dropdownListBO = responseTendineInventory.dropdownListBO;
    this.dropdownListOrderCluster = responseTendineInventory.dropdownListOrderCluster;
    this.dropdownListMonth = responseTendineInventory.dropdownListMonth;
    this.dropdownListYear = responseTendineInventory.dropdownListYear;
    this.dropdownListOrderType = responseTendineInventory.dropdownListOrderType;
    this.dropdownListOrderStatus = responseTendineInventory.dropdownListOrderStatus;
    this.dropdownListLead = responseTendineInventory.dropdownListLead;
  }

  viewTab() {
    let res: boolean = false;
    if (this.dropdownListBO && this.dropdownListOrderCluster && this.dropdownListMonth
      && this.dropdownListYear && this.dropdownListOrderType && this.dropdownListCustomer
      && this.dropdownListCountry && this.dropdownListLead && this.dropdownListOrderStatus) {
      res = true;
    }
    return res;
  }



  loadReportOrderDetail(req: any) {

    this.spinner.show("sp1");
    let urlReport: string = environment.basePath + _ENDPOINT.getReport;
    let requestOrderDetailPaginationDto = {
      lastTimeStamp: '',
      limit: 25,
      idLastOrder: ''
    }
    let filter: any = {};
    if (req && req.selectedItemsOrderStatus && req.selectedItemsOrderStatus.length == 0) {
      let states: any[] = this.createTendinaAllStatus();
      filter = {
        selectedItemsOrderStatus: states,
        selectedItemsYear: req.selectedItemsYear,
        selectedItemsMonth: req.selectedItemsMonth,
        selectedItemsCountry: req.selectedItemsCountry,
        selectedItemsCustomer: req.selectedItemsCustomer,
        selectedItemsOrderType: req.selectedItemsOrderType,
        selectedItemsBO: req.selectedItemsBO,
        selectedItemsIdGlobal: req.selectedItemsIdGlobal,
        selectedItemsLead: req.selectedItemsLead,
        selectedItemsOrderCluster: req.selectedItemsOrderCluster
      }
    } else {
      filter = req;
    }
    let request = {
      filter: filter,
      type: "ORDER_DETAIL",
      requestOrderDetailPaginationDto: requestOrderDetailPaginationDto,
      mapIdGlobalsByCustomerKey: this.createListCountryIds()
    }
    let data = Utility.createBodyForPostRequest(request, false);
    this.networkService.post(urlReport, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {
        if (this.networkService.checkEnvironmentIsDev()) {
          if (response && response.statusCode == '200' && response.body && response.body.length > 0) {
            this.reportResponse = JSON.parse(response.body);
            this.createReportOrderDetail();
            this.reportingService.setOrderDetailLoaded();
            this.setSelectedItemsOrderDetail();

            this.spinner.hide("sp1");

          } else if (response && response.statusCode == '500' && response.body && response.body.length > 0) {
            this.spinner.hide('sp1');
            this.toastr.errorToastr(response.body, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        } else {
          if (response && response.responseReportOrderDetailDto) {
            this.reportResponse = response;
            this.createReportOrderDetail();
            this.reportingService.setOrderDetailLoaded();
            this.setSelectedItemsOrderDetail();
            this.spinner.hide("sp1");
          } else if (response && response.length && response.length > 0) {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr(response.toString(), 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          } else {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr('Error during Reports Retrieve', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        }
      },
        err => {
          this.spinner.hide("sp1");
          this.toastr.errorToastr('Error during Reports Retrieve', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          console.error(err);
        });
  }

  loadReportOrderDetailSelected(req: any) {
    this.spinner.show("sp1");
    let urlReport: string = environment.basePath + _ENDPOINT.getReport;
    let order: any;
    if (this.listOrder && this.listOrder.length > 0) {
      order = this.listOrder[this.listOrder.length - 1];
    }
    let requestOrderDetailPaginationDto = {
      lastTimeStamp: order.dynamoOrderDate,
      limit: 25,
      idLastOrder: order.orderId
    }
    let filter: any = {};
    if (req && req.selectedItemsOrderStatus && req.selectedItemsOrderStatus.length == 0) {
      let states: any[] = this.createTendinaAllStatus();
      filter = {
        selectedItemsOrderStatus: states,
        selectedItemsYear: req.selectedItemsYear,
        selectedItemsMonth: req.selectedItemsMonth,
        selectedItemsCountry: req.selectedItemsCountry,
        selectedItemsCustomer: req.selectedItemsCustomer,
        selectedItemsOrderType: req.selectedItemsOrderType,
        selectedItemsBO: req.selectedItemsBO,
        selectedItemsIdGlobal: req.selectedItemsIdGlobal,
        selectedItemsLead: req.selectedItemsLead,
        selectedItemsOrderCluster: req.selectedItemsOrderCluster
      }
    } else {
      filter = req;
    }
    let request = {
      filter: filter,
      type: "ORDER_DETAIL",
      requestOrderDetailPaginationDto: requestOrderDetailPaginationDto,
      mapIdGlobalsByCustomerKey: this.createListCountryIds()
    }
    let data = Utility.createBodyForPostRequest(request, false);
    this.networkService.post(urlReport, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {
        if (this.networkService.checkEnvironmentIsDev()) {
          if (response && response.statusCode == '200' && response.body && response.body.length > 0) {
            this.reportResponse = JSON.parse(response.body);
            this.loadOtherReportOrderDetail();
            this.spinner.hide("sp1");

          } else if (response && response.statusCode == '500' && response.body && response.body.length > 0) {
            this.spinner.hide('sp1');
            this.toastr.errorToastr(response.body, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        } else {
          if (response && response.responseReportOrderDetailDto) {
            this.reportResponse = response;
            this.loadOtherReportOrderDetail();
            this.spinner.hide("sp1");
          } else if (response && response.length && response.length > 0) {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr(response.toString(), 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          } else {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr('Error during Reports Retrieve', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        }
      },
        err => {
          this.spinner.hide("sp1");
          this.toastr.errorToastr('Error during Reports Retrieve', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          console.error(err);
        });
  }

  loadReportOverview(req: any) {
    this.spinner.show("sp1");
    let urlReport: string = environment.basePath + _ENDPOINT.getReport;
    let requestOrderDetailPaginationDto = {
      lastTimeStamp: '',
      limit: 25,
      idLastOrder: ''
    }
    let filter: any = {};
    if (req && req.selectedItemsOrderStatus && req.selectedItemsOrderStatus.length == 0) {
      let states: any[] = this.createTendinaAllStatus();
      filter = {
        selectedItemsOrderStatus: states,
        selectedItemsYear: req.selectedItemsYear,
        selectedItemsMonth: req.selectedItemsMonth,
        selectedItemsCountry: req.selectedItemsCountry,
        selectedItemsCustomer: req.selectedItemsCustomer,
        selectedItemsOrderType: req.selectedItemsOrderType,
        selectedItemsBO: req.selectedItemsBO,
        selectedItemsIdGlobal: req.selectedItemsIdGlobal,
        selectedItemsLead: req.selectedItemsLead,
        selectedItemsOrderCluster: req.selectedItemsOrderCluster
      }
    } else {
      filter = req;
    }
    let request = {
      filter: filter,
      type: "OVERVIEW",
      requestOrderDetailPaginationDto: requestOrderDetailPaginationDto,
      mapIdGlobalsByCustomerKey: this.createListCountryIds()
    }
    let data = Utility.createBodyForPostRequest(request, false);
    this.networkService.post(urlReport, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {
        if (this.networkService.checkEnvironmentIsDev()) {
          if (response && response.statusCode == '200' && response.body && response.body.length > 0) {
            this.reportResponse = JSON.parse(response.body);
            this.createReportOverview();
            this.reportingService.setOverviewLoaded();
            this.setSelectedItemsOverview();

            this.spinner.hide("sp1");

          } else if (response && response.statusCode == '500' && response.body && response.body.length > 0) {
            this.spinner.hide('sp1');
            this.toastr.errorToastr(response.body, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        } else {
          if (response && response.responseReportOverviewDto) {
            this.reportResponse = response;
            this.createReportOverview();
            this.reportingService.setOverviewLoaded();
            this.setSelectedItemsOverview();

            this.spinner.hide("sp1");
          } else if (response && response.length && response.length > 0) {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr(response.toString(), 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          } else {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr('Error during Reports Retrieve', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        }
      },
        err => {
          this.spinner.hide("sp1");
          this.toastr.errorToastr('Error during Reports Retrieve', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          console.error(err);
        });
  }

  createReportOverview() {
    if (this.reportResponse && this.reportResponse.responseReportOverviewDto) {
      if (this.reportResponse.responseReportOverviewDto.listOrderTable) {
        this.orders = this.reportResponse.responseReportOverviewDto.listOrderTable;
      }
      if (this.reportResponse.responseReportOverviewDto.listLabelDataSet
        && this.reportResponse.responseReportOverviewDto.listLabelDataSet.length > 0) {
        let pieChartLabels: Label[] = [];
        let pieChartData: SingleDataSet = [];
        for (let elem of this.reportResponse.responseReportOverviewDto.listLabelDataSet) {
          if (elem.chartDataSet > 0) {
            pieChartLabels.push(elem.chartLabel);
            pieChartData.push(elem.chartDataSet);
          }
        }
        this.pieChartLabels = pieChartLabels;
        this.pieChartData = pieChartData;
      } else if (this.reportResponse.responseReportOverviewDto.listLabelDataSet
        && this.reportResponse.responseReportOverviewDto.listLabelDataSet.length == 0) {
        let pieChartLabels: Label[] = [];
        let pieChartData: SingleDataSet = [];

        this.pieChartLabels = pieChartLabels;
        this.pieChartData = pieChartData;
      }
      this.reportingService.setInfoOverview(this.pieChartLabels, this.pieChartData, this.orders)
    }
  }

  loadReportSlaKpi(req: any) {
    this.spinner.show("sp1");
    let urlReport: string = environment.basePath + _ENDPOINT.getReport;
    let requestOrderDetailPaginationDto = {
      lastTimeStamp: '',
      limit: 25,
      idLastOrder: ''
    }
    let filter: any = {};
    if (req && req.selectedItemsOrderStatus && req.selectedItemsOrderStatus.length == 0) {
      let states: any[] = this.createTendinaOnlyStatusCompleted();
      filter = {
        selectedItemsOrderStatus: states,
        selectedItemsYear: req.selectedItemsYear,
        selectedItemsMonth: req.selectedItemsMonth,
        selectedItemsCountry: req.selectedItemsCountry,
        selectedItemsCustomer: req.selectedItemsCustomer,
        selectedItemsOrderType: req.selectedItemsOrderType,
        selectedItemsBO: req.selectedItemsBO,
        selectedItemsIdGlobal: req.selectedItemsIdGlobal,
        selectedItemsLead: req.selectedItemsLead,
        selectedItemsOrderCluster: req.selectedItemsOrderCluster
      }
    } else {
      filter = req;
    }
    let request = {
      filter: filter,
      type: "SLA_KPIS",
      requestOrderDetailPaginationDto: requestOrderDetailPaginationDto,
      mapIdGlobalsByCustomerKey: this.createListCountryIds()
    }
    let data = Utility.createBodyForPostRequest(request, false);
    this.networkService.post(urlReport, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {
        if (this.networkService.checkEnvironmentIsDev()) {
          if (response && response.statusCode == '200' && response.body && response.body.length > 0) {
            this.reportResponse = JSON.parse(response.body);
            this.createReportSlaKpiPie();
            this.reportingService.setSlaKpisLoaded();
            this.setSelectedItemsSlaKpis();


            this.spinner.hide("sp1");

          } else if (response && response.statusCode == '500' && response.body && response.body.length > 0) {
            this.spinner.hide('sp1');
            this.toastr.errorToastr(response.body, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        } else {
          if (response && response.responseReportSlaKpisDto) {
            this.reportResponse = response;
            this.createReportSlaKpiPie();
            this.reportingService.setSlaKpisLoaded();
            this.setSelectedItemsSlaKpis();

            this.spinner.hide("sp1");
          } else if (response && response.length && response.length > 0) {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr(response.toString(), 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          } else {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr('Error during Reports Retrieve', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        }
      },
        err => {
          this.spinner.hide("sp1");
          this.toastr.errorToastr('Error during Reports Retrieve', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          console.error(err);
        });
  }



  loadReportCompletedDetail(req: any) {
    this.spinner.show("sp1");
    let urlReport: string = environment.basePath + _ENDPOINT.getReport;
    let requestOrderDetailPaginationDto = {
      lastTimeStamp: '',
      limit: 25,
      idLastOrder: ''
    }
    let filter: any = {};
    if (req && req.selectedItemsOrderStatus && req.selectedItemsOrderStatus.length == 0) {
      let states: any[] = this.createTendinaOnlyStatusCompleted();
      filter = {
        selectedItemsOrderStatus: states,
        selectedItemsYear: req.selectedItemsYear,
        selectedItemsMonth: req.selectedItemsMonth,
        selectedItemsCountry: req.selectedItemsCountry,
        selectedItemsCustomer: req.selectedItemsCustomer,
        selectedItemsOrderType: req.selectedItemsOrderType,
        selectedItemsBO: req.selectedItemsBO,
        selectedItemsIdGlobal: req.selectedItemsIdGlobal,
        selectedItemsLead: req.selectedItemsLead,
        selectedItemsOrderCluster: req.selectedItemsOrderCluster
      }
    } else {
      filter = req;
    }
    let request = {
      filter: filter,
      type: "COMPLETED_DETAIL",
      requestOrderDetailPaginationDto: requestOrderDetailPaginationDto,
      mapIdGlobalsByCustomerKey: this.createListCountryIds()
    }
    let data = Utility.createBodyForPostRequest(request, false);
    this.networkService.post(urlReport, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {
        if (this.networkService.checkEnvironmentIsDev()) {
          if (response && response.statusCode == '200' && response.body && response.body.length > 0) {
            this.reportResponse = JSON.parse(response.body);
            this.createReportCompletedDetail();
            this.reportingService.setCompletedDetailLoaded();
            this.setSelectedItemsCompletedDetail();

            this.spinner.hide("sp1");

          } else if (response && response.statusCode == '500' && response.body && response.body.length > 0) {
            this.spinner.hide('sp1');
            this.toastr.errorToastr(response.body, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        } else {
          if (response && response.responseCompletedDetailDto) {
            this.reportResponse = response;
            this.createReportCompletedDetail();
            this.reportingService.setCompletedDetailLoaded();
            this.setSelectedItemsCompletedDetail();

            this.spinner.hide("sp1");
          } else if (response && response.length && response.length > 0) {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr(response.toString(), 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          } else {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr('Error during Reports Retrieve', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        }
      },
        err => {
          this.spinner.hide("sp1");
          this.toastr.errorToastr('Error during Reports Retrieve', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          console.error(err);
        });
  }

  createReportCompletedDetail() {
    if (this.reportResponse && this.reportResponse.responseCompletedDetailDto) {
      let chart_Data: ChartDataSets[] = [];
      let label: Label[] = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      if (this.reportResponse.responseCompletedDetailDto.listChart
        && this.reportResponse.responseCompletedDetailDto.listChart.length > 0) {

        let arrayChartDate: any[] = this.reportResponse.responseCompletedDetailDto.listChart;
        let cont: number = 0;
        for (let elem of arrayChartDate) {
          let arrayTotMonth: number[] = [];
          for (let numbers of elem.tot) {
            if (numbers > 0) {
              arrayTotMonth.push(numbers);
            } else {
              arrayTotMonth.push(NaN);
            }
          }
          let chartDataElem: ChartDataSets = {
            label: elem.labelYear,
            data: arrayTotMonth,
            borderColor: this.colors[cont],
            fill: false,
            lineTension: 0
          };
          chart_Data.push(chartDataElem);
          cont++;
        }


      }
      this.chart_DataCompleted = chart_Data;
      this.chart_Labels = label;
      this.reportingService.setInfoCompletedDetail(this.chart_DataCompleted, this.chart_Labels);
    }
  }

  createReportOrderDetail() {
    if (this.reportResponse && this.reportResponse.responseReportOrderDetailDto &&
      this.reportResponse.responseReportOrderDetailDto.listReportOrderDetailDto) {
      this.listOrder = this.reportResponse.responseReportOrderDetailDto.listReportOrderDetailDto;
      this.reportingService.setInfoListOrdersDetail(this.listOrder);
    }
  }

  loadOtherReportOrderDetail() {
    if (this.reportResponse && this.reportResponse.responseReportOrderDetailDto &&
      this.reportResponse.responseReportOrderDetailDto.listReportOrderDetailDto) {
      let newArrayorder: any[] = [];
      this.listOrderSelected = this.reportResponse.responseReportOrderDetailDto.listReportOrderDetailDto;
      newArrayorder = this.listOrder.concat(this.listOrderSelected);
      this.listOrder = newArrayorder;
      this.reportingService.setInfoListOrdersDetail(this.listOrder);
    }
  }

  createReportSlaKpiPie() {
    if (this.reportResponse && this.reportResponse.responseReportSlaKpisDto) {
      if (this.reportResponse.responseReportSlaKpisDto.listAverage) {
        this.listAverage = this.reportResponse.responseReportSlaKpisDto.listAverage;
      }
      if (this.reportResponse.responseReportSlaKpisDto.listKpiPieDto
        && this.reportResponse.responseReportSlaKpisDto.listKpiPieDto.length > 0) {
        let pieChartLabels: Label[] = [];
        let pieChartData: SingleDataSet = [];
        for (let elem of this.reportResponse.responseReportSlaKpisDto.listKpiPieDto) {
          if (elem.chartDataSet > 0) {
            pieChartLabels.push(elem.chartLabel);
            pieChartData.push(elem.chartDataSet);
          }
        }
        this.labelSlaKpi = pieChartLabels.reverse();
        this.singleDataSetSlaKpi = pieChartData.reverse();
      } else if (this.reportResponse.responseReportSlaKpisDto.listKpiPieDto
        && this.reportResponse.responseReportSlaKpisDto.listKpiPieDto.length == 0) {
        let pieChartLabels: Label[] = [];
        let pieChartData: SingleDataSet = [];

        this.labelSlaKpi = pieChartLabels;
        this.singleDataSetSlaKpi = pieChartData;
      }
      this.reportingService.setInfoSlaKpis(this.listAverage, this.labelSlaKpi, this.singleDataSetSlaKpi);
    }
  }

  setSelectedItemsOverview() {
    this.reportingService.setSelectedItemsOverview({
      selectedItemsYear: this.selectedItemsYear,
      selectedItemsMonth: this.selectedItemsMonth,
      selectedItemsCountry: this.selectedItemsCountry,
      selectedItemsCustomer: this.selectedItemsCustomer,
      selectedItemsOrderType: this.selectedItemsOrderType,
      selectedItemsBO: this.selectedItemsBO,
      selectedItemsIdGlobal: this.selectedItemsIdGlobal,
      selectedItemsLead: this.selectedItemsLead,
      selectedItemsOrderStatus: this.selectedItemsOrderStatus,
      selectedItemsOrderCluster: this.selectedItemsOrderCluster
    });
    this.reportingService.setDropdownItemsOverview(this.reportResponse.responseReportOverviewDto.requestFilterDto);
  }

  setSelectedItemsOrderDetail() {
    this.reportingService.setSelectedItemsOrderDetail({
      selectedItemsYear: this.selectedItemsYear,
      selectedItemsMonth: this.selectedItemsMonth,
      selectedItemsCountry: this.selectedItemsCountry,
      selectedItemsCustomer: this.selectedItemsCustomer,
      selectedItemsOrderType: this.selectedItemsOrderType,
      selectedItemsBO: this.selectedItemsBO,
      selectedItemsIdGlobal: this.selectedItemsIdGlobal,
      selectedItemsLead: this.selectedItemsLead,
      selectedItemsOrderStatus: this.selectedItemsOrderStatus,
      selectedItemsOrderCluster: this.selectedItemsOrderCluster
    });
    this.reportingService.setDropdownItemsOrderDetail(this.reportResponse.responseReportOrderDetailDto.requestFilterDto);
  }

  setSelectedItemsSlaKpis() {
    this.reportingService.setSelectedItemsSlaKpis({
      selectedItemsYear: this.selectedItemsYear,
      selectedItemsMonth: this.selectedItemsMonth,
      selectedItemsCountry: this.selectedItemsCountry,
      selectedItemsCustomer: this.selectedItemsCustomer,
      selectedItemsOrderType: this.selectedItemsOrderType,
      selectedItemsBO: this.selectedItemsBO,
      selectedItemsIdGlobal: this.selectedItemsIdGlobal,
      selectedItemsLead: this.selectedItemsLead,
      selectedItemsOrderStatus: this.selectedItemsOrderStatus,
      selectedItemsOrderCluster: this.selectedItemsOrderCluster
    });
    this.reportingService.setDropdownItemsSlaKpis(this.reportResponse.responseReportSlaKpisDto.requestFilterDto);
  }

  setSelectedItemsCompletedDetail() {
    this.reportingService.setSelectedItemsCompletedDetail({
      selectedItemsYear: this.selectedItemsYear,
      selectedItemsMonth: this.selectedItemsMonth,
      selectedItemsCountry: this.selectedItemsCountry,
      selectedItemsCustomer: this.selectedItemsCustomer,
      selectedItemsOrderType: this.selectedItemsOrderType,
      selectedItemsBO: this.selectedItemsBO,
      selectedItemsIdGlobal: this.selectedItemsIdGlobal,
      selectedItemsLead: this.selectedItemsLead,
      selectedItemsOrderStatus: this.selectedItemsOrderStatus,
      selectedItemsOrderCluster: this.selectedItemsOrderCluster
    });
    this.reportingService.setDropdownItemsCompletedDetail(this.reportResponse.responseCompletedDetailDto.requestFilterDto);
  }

  createListCountryIds() {
    let array: any[] = [];
    for (let [key, value] of this.idLeadGlobalOfCustomerName) {
      let data: any = {
        ids: value,
        customer: key
      }
      array.push(data);
    }
    return array;
  }

  createTendinaAllStatus() {
    return this.dropdownListOrderStatus;
  }

  createTendinaOnlyStatusCompleted() {
    let array: any[] = [];
    let data: any = {
      item_id: "COMPLETED",
      item_text: "COMPLETED",
    }
    array.push(data);
    return array;
  }



  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
